module.exports = __webpack_public_path__ + "img/profile-bg-transparent.1d849723.png";